import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/router-compatibility';
import useUnleashHook from '../../core/unleash/useUnleashHook';
import { UnleashService } from '../../services';
import LocationManagement from './location-management';

export const LocationManagementRoute = (props) => {
  const isFlagEnabled = useUnleashHook(UnleashService.FLAGS.SPLIT_LOCATION_USER_MANAGEMENT).isFlagEnabled;
  if (!isFlagEnabled()) {
    return <Navigate to="/manage" replace />;
  }
  return <LocationManagement {...props} />;
};

const mapStateToProps = (state) => state.app;

export default connect(mapStateToProps)(withRouter(LocationManagementRoute));
